import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const StadiumIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M4.5 4.5753V1.28243C4.5 1.12645 4.62645 1 4.78243 1C4.92616 1 5.06856 1.02742 5.20201 1.0808L7.5 2L5 3V4.42037C6.80435 3.90712 8.68311 3.86386 10.5 4.29059V1.28243C10.5 1.12645 10.6264 1 10.7824 1C10.9262 1 11.0686 1.02742 11.202 1.0808L13.5 2L11 3V4.42037C11.6664 4.60992 12.3226 4.86358 12.9618 5.18134C12.985 5.19285 13 5.21926 13 5.24849V6.99935C13 7.32745 12.6893 7.5665 12.3695 7.49325C9.49823 6.83558 6.50177 6.83558 3.63053 7.49325C3.31072 7.5665 3 7.32745 3 6.99935V5.24849C3 5.21926 3.01501 5.19285 3.03817 5.18134C3.51687 4.94337 4.0051 4.74136 4.5 4.5753Z"
		></path>
		<path
			fill="currentColor"
			d="M1 9.42684V14.5266C1 14.788 1.22386 15 1.5 15H5.5C5.77614 15 6 14.7761 6 14.5V13.6525C6 12.5658 6.26149 11.3373 7.31711 11.0792C7.5203 11.0295 7.74761 11 8 11C8.25238 11 8.4797 11.0295 8.68288 11.0792C9.73851 11.3373 10 12.5658 10 13.6525V14.5C10 14.7761 10.2239 15 10.5 15H14.5C14.7761 15 15 14.788 15 14.5266V9.42684C15 9.39345 14.979 9.36326 14.9466 9.3501C10.5106 7.54996 5.48937 7.54996 1.05344 9.3501C1.02102 9.36326 1 9.39345 1 9.42684Z"
		></path>
	</svg>
))
